var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48,
    stroke: "#FF7816",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5154 34.9396L67.5179 34.9421C71.374 38.7982 71.8103 45.4871 66.5783 50.8229L50.2296 67.1716L33.8809 50.8229C28.6488 45.4871 29.0851 38.7982 32.9413 34.9421L32.9437 34.9396C33.8722 34.0078 34.9756 33.2686 36.1904 32.7641C37.4053 32.2597 38.7077 32 40.0231 32C41.3386 32 42.641 32.2597 43.8559 32.7641C45.0693 33.268 46.1715 34.0061 47.0994 34.9364C47.1004 34.9375 47.1015 34.9385 47.1026 34.9396L48.8063 36.6654L50.2296 38.1072L51.6529 36.6654L53.3566 34.9396C53.3576 34.9385 53.3587 34.9375 53.3598 34.9364C54.2876 34.0061 55.3898 33.268 56.6033 32.7641C57.8181 32.2597 59.1206 32 60.436 32C61.7514 32 63.0539 32.2597 64.2687 32.7641C65.4836 33.2686 66.5869 34.0078 67.5154 34.9396Z",
    stroke: "#FF7816",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.af17b600247ad87e104b82624160ea76.svg";
export { ForwardRef as ReactComponent };